import axios from 'axios';
import { showTabs, selectTab } from '../common/tab/tabActions';
import consts from '../consts';
import { setErroAPI, setSuccess } from '../common/toast/toast';
import { reset as resetForm, initialize } from 'redux-form';
import DateFormat from '../common/dateFormat/DateFormat';
import FormatUtils from '../common/formatUtils/FormatUtils';

export function setModoTela(modo, registro = {}) {
    return {
        type: 'CLIENTE_MODO_TELA',
        payload: {
			modo: modo,
			registro: registro
		}
    };
}

export function setAguardando(aguardando) {
    return {
        type: 'CLIENTE_SET_AGUARDANDO',
        payload: aguardando
    };
}

export function initForm(registro = {}) {
    return [
        initialize('clienteForm', registro)
    ];
}

export function getLista() {
	return (dispatch, getState) => {
		axios.get(`${consts.API_URL}/cliente?id_usuario=${getState().auth.usuario.id}`).then(result => {
			dispatch({
				type: 'CLIENTE_LISTADO',
				payload: result
			});
		}).catch(e => {
			console.log(e);
		});
	}
}

export function salvar(registro) {
    return (dispatch, getState) => {
		if (!registro.id) {
	        axios.post(`${consts.API_URL}/cliente`, {
				...registro,
				cpf_cnpj: FormatUtils.removerMascara(registro.cpf_cnpj),
				cep: FormatUtils.removerMascara(registro.cep),
				id_usuario_inclusao: getState().auth.usuario.id,
				id_usuario_alteracao: getState().auth.usuario.id
			}).then(resp => {
				setSuccess('Operação Realizada com sucesso.');
				dispatch(getLista());
				dispatch(setModoTela('lista'));
			}).catch(e => {
				setErroAPI(e);
			});
		} else {
			axios.put(`${consts.API_URL}/cliente`, {
				...registro,
				cpf_cnpj: FormatUtils.removerMascara(registro.cpf_cnpj),
				cep: FormatUtils.removerMascara(registro.cep),
				id_usuario_alteracao: getState().auth.usuario.id
			}).then(resp => {
				setSuccess('Operação Realizada com sucesso.');
				dispatch(getLista());
				dispatch(setModoTela('lista'));
			}).catch(e => {
				setErroAPI(e);
			});
		}
    };
}

export function excluir(registro) {
    return (dispatch, getState) => {
        axios.delete(`${consts.API_URL}/cliente?id=${registro.id}&id_usuario_alteracao=${getState().auth.usuario.id}`)
		.then(resp => {
			setSuccess('Operação Realizada com sucesso.');
			dispatch(getLista());
			dispatch(setModoTela('lista'));
		}).catch(e => {
			setErroAPI(e);
		});
    };
}

export function getListaGrupo() {
	return (dispatch, getState) => {
		axios.get(`${consts.API_URL}/grupoCliente/listarSelect?id_usuario=${getState().auth.usuario.id}`).then(result => {
			dispatch({
				type: 'CLIENTE_GRUPO_SELECT_LISTADO',
				payload: result
			});
		}).catch(e => {
			console.log(e);
		});
	}
}

export function getListaCidade() {
    const request = axios.get(`${consts.API_URL}/cidade/listarSelectGeral`);
    return {
        type: 'CLIENTE_CIDADE_SELECT_LISTADO',
        payload: request
    };
}

export function getListaPais() {
    const request = axios.get(`${consts.API_URL}/pais/listarSelect`);
    return {
        type: 'CLIENTE_PAIS_SELECT_LISTADO',
        payload: request
    };
}

export function importar(tabela) {
    return async (dispatch, getState) => {

		dispatch(setAguardando(true));
		
		let listaCidade = [];
		await axios.get(`${consts.API_URL}/cidade/listarSelectGeral`).then(result => {
			listaCidade = result.data;
		});
		
		let listaGrupo = [];
		await axios.get(`${consts.API_URL}/grupoCliente/listarSelect`).then(result => {
			listaGrupo = result.data;
		});

		let listaGruposImportar = [];
		for (var i = 1; i < tabela.length; i++) {
			let item = tabela[i];

			if (!listaGruposImportar.includes(String(String(item[5] || '').trim())) 
				&& !listaGrupo.filter(grupo => grupo.valor == String(String(item[5] || '').trim())).length) {
				listaGruposImportar.push(String(String(item[5] || '').trim()));
				
				// await axios.post(`${consts.API_URL}/grupoCliente`, {
				// 	nome: (String(String(item[5] || '').trim())),
				// 	id_usuario_inclusao: getState().auth.usuario.id,
				// 	id_usuario_alteracao: getState().auth.usuario.id
				// });
			}
		}

		await axios.get(`${consts.API_URL}/grupoCliente/listarSelect`).then(result => {
			listaGrupo = result.data;
		});

		let listaCliente = [];
		await axios.get(`${consts.API_URL}/cliente`).then(result => {
			listaCliente = result.data;
		});

		let removerAcento = str => {
			return str.normalize("NFD")
              .replace(/[\u0300-\u036f]/g, "") // Remove diacríticos (acentos)
              .replace(/[çÇ]/g, "c")           // Substitui ç e Ç por c
              .replace(/[^\w\s]/g, "")
		}

		let listaClientesImportar = [];
		for (var i = 1; i < tabela.length; i++) {
			let item = tabela[i];

			let cliente = {

				id_integracao: String(String(item[0] || '').trim()),
				nome: String(String(item[1] || '').trim()),
				cpf_cnpj: FormatUtils.removerMascara(item[2] ? String(String(item[2] || '').trim().padStart('0', 14)) : String(String(item[3] || '').trim().padStart('0', 11))),
				inscricao_estadual: String(item[4] || '').trim(),
				id_grupo: listaGrupo.filter(grupo => grupo.valor.toUpperCase() == String(String(item[5] || '').toUpperCase().trim()))[0] 
						? listaGrupo.filter(grupo => grupo.valor.toUpperCase() == String(String(item[5] || '').toUpperCase().trim()))[0].id : null,
				id_cidade: listaCidade.filter(cidade => removerAcento(cidade.valor.toUpperCase().replace("'", '')) == removerAcento(String(String(item[7] || '').toUpperCase().replace("'", '').trim())))[0] 
						? listaCidade.filter(cidade => removerAcento(cidade.valor.toUpperCase().replace("'", '')) == removerAcento(String(String(item[7] || '').toUpperCase().replace("'", '').trim())))[0].id : null,
				endereco: String(String(item[8] || '').trim()),
				// numero: String(String(item[9] || '').trim()).length > 10 ? '' : String(String(item[9] || '').trim()),
				// bairro: String(String(item[10] || '').trim()),
				cep: '',
				id_usuario_inclusao: getState().auth.usuario.id,
				id_usuario_alteracao: getState().auth.usuario.id
			};

			// if (!cliente.id_cidade) {
			// 	console.log(`UPDATE cliente SET id_cidade = ${cliente.id_cidade} WHERE id_integracao = ${cliente.id_integracao} and id_cidade is null;`);
			// }
			

			if (cliente.id_integracao
				&& cliente.id_grupo 
				&& !listaClientesImportar.includes(cliente.id_integracao) 
				&& !listaCliente.filter(clienteAux => clienteAux.id_integracao == cliente.id_integracao).length) {
					listaClientesImportar.push(cliente.id_integracao);
					console.log(listaClientesImportar.length);
					console.log(cliente);

				await axios.post(`${consts.API_URL}/cliente`, {
					...cliente,
					id_usuario_inclusao: getState().auth.usuario.id,
					id_usuario_alteracao: getState().auth.usuario.id
				}).then(resp => {
					console.log(`Incluido ${i+ 1} de ${tabela.length}`);
				}).catch(e => {
					console.log(e);
				});
				
			} else if (cliente.id_integracao
				&& cliente.id_grupo 
				&& listaCliente.filter(clienteAux => clienteAux.id_integracao == cliente.id_integracao).length) {
					listaClientesImportar.push(cliente.id_integracao);
					
				const clienteCadastrado = listaCliente.filter(clienteAux => clienteAux.id_integracao == cliente.id_integracao)[0];

				if (clienteCadastrado.id_grupo != cliente.id_grupo
					|| clienteCadastrado.inscricao_estadual != cliente.inscricao_estadual
					|| clienteCadastrado.id_cidade != cliente.id_cidade
					|| clienteCadastrado.endereco != cliente.endereco) {

					console.log(({
						...clienteCadastrado,
						id_grupo: cliente.id_grupo,
						inscricao_estadual: cliente.inscricao_estadual,
						id_cidade: cliente.id_cidade,
						endereco: cliente.endereco,
						id_usuario_alteracao: getState().auth.usuario.id
					}));

					await axios.put(`${consts.API_URL}/cliente`, {
						...clienteCadastrado,
						id_grupo: cliente.id_grupo,
						inscricao_estadual: cliente.inscricao_estadual,
						id_cidade: cliente.id_cidade,
						endereco: cliente.endereco,
						id_usuario_alteracao: getState().auth.usuario.id
					}).then(resp => {
						console.log(`Alterado ${i+ 1} de ${tabela.length}`);
					}).catch(e => {
						console.log(e);
					});
				}
				
			}
						
		}

		setSuccess('Importação Realizada com sucesso.');
		dispatch(getLista());
		dispatch(setAguardando(false));
    };
}
